import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AdirDetailsSideNavigation } from '@projects/adir/src/app/pages/adir-details/adir-details-side-navigation/adir-details-side-navigation.interface';
import { TailwindMerge } from '@shared/src/interfaces/TwMerge.interface';
import { CardComponent } from '@shared/src/lib/components/card/card.component';
import { DynamicIconDirective } from '@shared/src/lib/directives/dynamic-icon.directive';

@Component({
  selector: 'app-adir-details-side-navigation',
  standalone: true,
  imports: [RouterModule, NgFor, DynamicIconDirective, CardComponent],
  templateUrl: './adir-details-side-navigation.component.html',
  styleUrl: './adir-details-side-navigation.component.css',
})
export class AdirDetailsSideNavigationComponent extends TailwindMerge {
  private _isMomDisabled: boolean;
  options: AdirDetailsSideNavigation.SideNavigationOptions = [
    {
      label: AdirDetailsSideNavigation.SIDE_NAVIGATION_OPTION_LABEL.MILESTONE_REVIEW_REQUEST_FORM,
      link: 'milestone-reviews',
      iconName: 'file-text',
      isDisabled: false,
    },
    {
      label: AdirDetailsSideNavigation.SIDE_NAVIGATION_OPTION_LABEL.MINUTES_OF_MEETING,
      link: 'minutes-of-meeting',
      iconName: 'clipboard',
      isDisabled: true,
    },
    {
      label: AdirDetailsSideNavigation.SIDE_NAVIGATION_OPTION_LABEL.ATTACHMENTS,
      link: 'attachments',
      iconName: 'attachment',
      isDisabled: false,
    },
    {
      label: AdirDetailsSideNavigation.SIDE_NAVIGATION_OPTION_LABEL.ACTIVITY_LOGS,
      link: 'activity-logs',
      iconName: 'time-stopwatch',
      isDisabled: false,
    },
  ];

  constructor(private readonly router: Router) {
    super();
  }

  @Input()
  set isMomDisabled(value: boolean) {
    if (value !== this._isMomDisabled) {
      this._isMomDisabled = value;
      this.updateOptions();
    }
  }

  get isMomDisabled(): boolean {
    return this._isMomDisabled;
  }

  private updateOptions() {
    const minutesOfMeetingOption = this.options.find(
      (option) => option.label === AdirDetailsSideNavigation.SIDE_NAVIGATION_OPTION_LABEL.MINUTES_OF_MEETING
    );

    if (minutesOfMeetingOption) {
      minutesOfMeetingOption.isDisabled = this.isMomDisabled;
    }
  }

  isCurrentRouteActive(pathname: string) {
    return this.router.url.includes(pathname);
  }
}
